var csv = [],
    $start = document.getElementById('start'),
    $container = document.getElementById('suppliers-container'),
    $results = document.getElementById('suppliers-results'),
    $filter = document.getElementById('suppliers-filter'),
    $empty = document.getElementById('suppliers-empty'),
    ns = {
        featured: staticSupplierFeatured,
        conversion: staticSupplierConversion,
        ads: staticSupplierAds,
        instagram: staticSupplierInstagram,
        name: staticSupplierName,
        slug: staticSupplierSlug,
        category: staticSupplierCategory,
        subcategory: staticSupplierSubcategory,
        cnpj: staticSupplierCnpj,
        url: staticSupplierUrl
    }

$template = document.getElementById('supplier-template').innerHTML;

var Controller = {
    count: 0,
    all_categories: [],
    categories: [],
    synonyms: [],
    suppliers: false,
    initialize: function () {
        if (!this.suppliers) {
            $start.className = "fade";
            $results.className = "loading";
            $results.innerHTML = $template.repeat(3);

            getSuppliers();
            getTaxonomies();

            setTimeout(() => {
                $start.className = "hide";
                $container.className = "";
            }, 500);
        }
    },

    update: function () {
        let filter = filterByTaxonomies(this.categories, true);
        $results.className = "";
        $results.innerHTML = "";
        this.count = 0;

        // append NS object to the list
        filter.splice(0, 0, ns);

        filter.forEach(fillSupplier);

        if (filter.length == 1) {
            $results.style.display = 'none';
            $empty.style.display = 'block';
        } else {
            $results.style.display = 'block';
            $empty.style.display = 'none';
        }

        calcResultsAmount();
        removeHiddenCode();
        loadMoreResults();
    }
}

// Filter suppliers by taxonomies
function filterByTaxonomies(categories, getSubcategories = false) {
    let result = [];

    Controller.suppliers.forEach(function (supplier) {
        let matchWithFilters = false;
        categories.forEach(function (category) {
            if (supplier.tax_category.startsWith(category) & !matchWithFilters) {
                result.push(supplier);
                matchWithFilters = true;
            }
        })
    })

    return result;
}

function getSuppliers() {
    $.ajax(sheet_url)
        .done(function (data) {
            Controller.suppliers = [];

            csv = data;
            csv = csv.split(/\n|\r\n/)

            cols = csv[0].split(",");
            csv = csv.slice(1)

            csv.forEach((row, index, array) => {
                let supplier = {}

                row = row.split(",")

                row.forEach((item, index) => {
                    supplier[cols[index]] = item;
                })

                Controller.suppliers.push(supplier)
            })

            Controller.update();
        });
}

// Get all available filters
function getTaxonomies() {
    $.ajax(taxonomies_url)
        .done(function (data) {

            csv = data;
            csv = csv.split(/\n|\r\n/)

            cols = csv[0].split(",");
            csv = csv.slice(1);

            csv.forEach((row) => {
                row = row.split(",");
                const rowCategory = row[0];
                const rowSynonyms = row[1];

                if (rowCategory) {
                    Controller.all_categories.push(rowCategory);
                }

                if (rowSynonyms) {
                    Controller.synonyms.push(rowSynonyms);
                }
            });

            // Create categories list
            var $filterGroupCategory = document.createElement('div');
            $filterGroupCategory.className = 'filter-group filter-group--category';
            $filterGroupCategory.innerHTML = '<h3>' + filterGroupCategory + '</h3>';

            var $filtersCategory = document.createElement('ul');
            var $parentCategory = null;
            var $childrenCategory = null;
            var parentCategory = Controller.all_categories[0].split('::')[0];

            Controller.all_categories.forEach(function (category, index) {

                var checked = category.startsWith(Controller.categories[0]) ? 'checked' : '';

                if (category.endsWith('::')) {
                    let nameCategory = category.split('::')[0];
                    parentCategory = nameCategory;
                    $parentCategory = document.createElement('li');
                    $parentCategory.innerHTML = '<input class="taxonomy-input" type="checkbox" id="parentCategory-' + index + '" name="' + category + '" ' + checked + '><label for="parentCategory-' + index + '">' + nameCategory + '</label>';
                    $filtersCategory.appendChild($parentCategory);

                    $parentCategory = null;
                    $childrenCategory = null;
                } else {
                    let nameCategory = category.split('::')[0];
                    if ($parentCategory == null | parentCategory != nameCategory) {
                        parentCategory = nameCategory;
                        $parentCategory = document.createElement('li');
                        $parentCategory.innerHTML = '<input class="taxonomy-input" type="checkbox" id="parentCategory-' + index + '" name="' + nameCategory + '::" ' + checked + '><label for="parentCategory-' + index + '">' + nameCategory + '</label>';
                        $childrenCategory = document.createElement('ul');
                        $childrenCategory.className = 'filter-group--subcategory p-left';
                        $parentCategory.appendChild($childrenCategory);
                        $filtersCategory.appendChild($parentCategory);
                    }

                    nameCategory = category.split('::').pop();

                    $childCategory = document.createElement('li');
                    $childCategory.innerHTML = '<input class="taxonomy-input" type="checkbox" id="childCategory-' + index + '" name="' + category + '" ' + checked + '><label for="childCategory-' + index + '">' + nameCategory + '</label>';
                    $childrenCategory.appendChild($childCategory);
                }
            });

            // Append filter groups in sidebar
            $filterGroupCategory.appendChild($filtersCategory);
            $filter.appendChild($filterGroupCategory);

            var elementTaxonomies = document.getElementsByClassName('taxonomy-input');

            var select = function () {
                getSelectedTaxonomies();
            };

            for (var i = 0; i < elementTaxonomies.length; i++) {
                elementTaxonomies[i].addEventListener('click', select, false);
            };

            setUpCheckbox();

        });
}

function startFromTaxonomy(e) {

    if (!$.cookie('tool_' + landing + '_subscribe_modal_gate') && HUBSPOT_FORM_EMBED.currenStep() != '1') {
        toolsSubscribe();

        $('#modal-subscribe').modal('show');

        document.addEventListener('onToolsSubscribe', function (params) {
            $('#modal-subscribe').modal('hide');
            Controller.categories = [e];
            Controller.initialize();

            $.cookie('tool_' + landing + '_subscribe_modal_gate', true, { expires: 30, path: '/' });

            amplitude_log_event('tools_subscribed', {
                'tool_name': landing
            });
        })

    } else {
        Controller.categories = [e];
        Controller.initialize();
    }

}

function replaceAll(find, replace, str) {
    if (!str) { str = this; }
    if (!replace) { replace = ''; }
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, 'g'), replace);
}

String.prototype.replaceAll = replaceAll;

// Fill supplier data inside each card
function fillSupplier(supplier) {
    let html = $template;
    let chip = '<div class="chip label label-small label-light m-right-half">$CATEGORY</div>';
    debugger;
    let chips = chip.replaceAll('$CATEGORY', supplier.category)
    chips += supplier.subcategory ? chip.replaceAll('$CATEGORY', supplier.subcategory) : '';

    html = html.replaceAll('$CHIPS', chips)
        .replaceAll('$DELAY', Controller.count * 100)
        .replaceAll('$IS_FEATURED', supplier.featured == 'TRUE' ? '' : 'hide')
        .replaceAll('$HAS_CONVERSION', supplier.conversion == 'TRUE' ? '' : 'hide')
        .replaceAll('$IS_ADS', supplier.ads ? 'supplier-dark' : '')
        .replaceAll('$NAME', supplier.name)
        .replaceAll('$CNPJ', supplier.cnpj)
        .replaceAll('$HIDE_CNPJ', supplier.cnpj ? '' : 'hide')
        .replaceAll('$STATE', supplier.state)
        .replaceAll('$URL', supplier.url)
        .replaceAll('$WEBSITE', supplier.url.replaceAll('https://')
            .replaceAll('www.')
            .replaceAll('http://').split('/')[0])
        .replaceAll('$INSTAGRAM', supplier.instagram)
        .replaceAll('$SHOW_INSTAGRAM', supplier.instagram != '' ? '' : 'hide')

    $results.insertAdjacentHTML('beforeend', html);

    Controller.count += 1;
}


function printDiv() {
    var divContents = $results.innerHTML;
    var a = window.open('', '', 'height=500, width=500');
    a.document.write('<html>');
    a.document.write('<body style="font-family: sans-serif;">');
    a.document.write(divContents);
    a.document.write('</body></html>');
    a.document.close();
    a.print();
}

var nodeArray = (selector, $p = document) => [].slice.call($p.querySelectorAll(selector)) || [];

function setUpCheckbox() {
    //  helper function to create nodeArrays (not collections)

    //  checkboxes of interest
    var allThings = nodeArray('input');

    //  global listener
    addEventListener('change', e => {
        let check = e.target;

        //  exit if change event did not come from
        //  our list of allThings
        if (allThings.indexOf(check) === -1) return;

        //  check/unchek children (includes check itself)
        var children = nodeArray('input', check.parentNode);
        children.forEach(child => child.checked = check.checked);

        //  traverse up from target check
        while (check) {
            try {

                //  find $p and sibling checkboxes (quick'n'dirty)
                var $p = (check.closest(['ul']).parentNode).querySelector('input');
                var siblings = nodeArray('input', $p.closest('li').querySelector(['ul']));

                //  get checked state of siblings
                //  are every or some siblings checked (using Boolean as test function)
                var checkStatus = siblings.map(check => check.checked);
                var every = checkStatus.every(Boolean);
                var some = checkStatus.some(Boolean);

                //  check $p if all siblings are checked
                //  set indeterminate if not all and not none are checked
                $p.checked = every;
                $p.indeterminate = !every && every !== some;

            } catch (error) {

            }
            //  prepare for nex loop
            check = check != $p ? $p : 0;
            getSelectedTaxonomies();
        }
    })
}

// Get which taxonomies are selected
function getSelectedTaxonomies() {
    Controller.categories = [];

    Array.from(document.getElementsByClassName('taxonomy-input')).forEach((item) => {
        if (item.checked) {
            Controller.categories.push(item.name);
        }
    });

    Controller.update();
}

// On demand loading
function loadMoreResults() {
    const resultsItems = Array.from($results.querySelectorAll('.supplier'));
    const btnMoreResults = document.querySelector('.js-more-results');
    maxItems = 6;
    loadItems = 6;
    hiddenClass = 'supplier-hidden';

    resultsItems.forEach(function (item, index) {
        if (index > maxItems - 1) {
            item.classList.add(hiddenClass);
        }
    });

    if(resultsItems.length > maxItems) {
        btnMoreResults.classList.remove('hide');
    }

    if (document.querySelectorAll("." + hiddenClass).length === 0) {
        btnMoreResults.classList.add('hide');
    }

    btnMoreResults.addEventListener('click', function() {
        [].forEach.call(document.querySelectorAll('.' + hiddenClass), function (item, index) {
            if (index < loadItems) {
                item.classList.remove(hiddenClass);
            }

            if (document.querySelectorAll("." + hiddenClass).length === 0) {
                btnMoreResults.classList.add('hide');
            }
        });
    });
}

// Calc amount of results
function calcResultsAmount() {
    const resultsItems = Array.from($results.querySelectorAll('.supplier'));
    const resultsAmountContainer = document.querySelector('.js-results-amount-container');
    const amountToReplace = document.querySelector('.js-results-amount');

    let resultsAmount = resultsItems.length;
    console.log(resultsAmount);

    if(resultsAmount > 1){
        resultsAmountContainer.classList.remove('hide');
        amountToReplace.innerHTML = resultsAmount;
    } else {
        resultsAmountContainer.classList.add('hide');
    }
}

// Collapse filter on mobile
const $toggle = document.getElementById('toggle-filters');

if (window.innerWidth < 991) {
    $filter.classList.add('collapse');

    $toggle.addEventListener('click', function () {
        $filter.classList.toggle('collapse');
    });
} else {
    $filter.classList.remove('collapse');
}

// Remove hidden html when card is not featured
function removeHiddenCode() {
    document.querySelectorAll('.supplier-featured').forEach((item) => {
        if(item.classList.contains('hide')){
            item.remove();
        }
    });
};
